<template>
    <app-layout title="Nastavení">

        <settings-tabs-navigation/>

        <div class="max-w-7xl mx-auto py-8 sm:px-6 lg:px-8">
            <info-bar :color="'red'" v-if="isPlannedMaintenance != null">
                Právě probíhá plánovaná odstávka systému datových schránek.
                Přidávání účtů a změny na této stránce nemusí fungovat správně.
                Plánovaný konec odstávky je
                {{ (new Date(isPlannedMaintenance.end)).toLocaleDateString() + ', ' + (new Date(isPlannedMaintenance.end)).toLocaleTimeString() }}.
            </info-bar>

            <div v-for="(account, index) in accounts" v-bind:key="account.id">
                <jet-form-section :working="workingUserId === account.id">
                    <template v-if="index === 0" #title>
                        Účty ISDS
                    </template>

                    <template v-if="index === 0" #description>
                        <p>Zde najdete informace o vašich účtech systému datových schránek a možnost je z DSchránky smazat.</p>
                    </template>

                    <template #badge>
                        {{ 'Přihlášeno ' + getMethodName(account.method) }}
                    </template>

                    <template #form>
                        <!-- Username -->
                        <div class="col-span-6 sm:col-span-4">
                            <div>
                                <label v-if="account.method === 2" :for="'username' + account.id" class="block text-sm font-medium text-gray-700">ID datové schránky</label>
                                <label v-else :for="'username' + account.id" class="block text-sm font-medium text-gray-700">Uživatelské jméno</label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input disabled :value="account.username" type="text" name="username" :id="'username' + account.id" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md">
                                </div>
                            </div>
                        </div>

                        <!-- Password -->
                        <div v-if="account.method === 0" class="col-span-6 sm:col-span-4">
                            <div>
                                <label :for="'password' + account.id" class="block text-sm font-medium text-gray-700">Heslo <i class="text-xs">({{ account.password_expiry == null ? 'neomezená platnost' : 'platné do ' + (new Date(account.password_expiry)).toLocaleDateString() }})</i></label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input disabled :value="account.password" :type="showPassword === index ? 'text' : 'password'" name="password" :id="'password' + account.id" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md" placeholder="000-00-0000">
                                    <confirms-password v-if="index !== showPassword" @confirmed="showPasswordOrKeyByIndex(index)" class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                                        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                            <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                                        </svg>
                                    </confirms-password>
                                    <div v-else @click="hideShownPasswordOrKey()" class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
                                            <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                                        </svg>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- MK Code -->
                        <div v-if="account.method === 4" class="col-span-6 sm:col-span-4">
                            <div>
                                <label :for="'code' + account.id" class="block text-sm font-medium text-gray-700">Komunikační kód</label>
                                <div class="mt-1 relative rounded-md shadow-sm">
                                    <input disabled :value="account.password" :type="showPassword === index ? 'text' : 'password'" name="password" :id="'code' + account.id" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md" placeholder="000-00-0000">
                                    <confirms-password v-if="index !== showPassword" @confirmed="showPasswordOrKeyByIndex(index)" class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                                        <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                            <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                            <path fill-rule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clip-rule="evenodd" />
                                        </svg>
                                    </confirms-password>
                                    <div v-else @click="hideShownPasswordOrKey()" class="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd" d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z" clip-rule="evenodd" />
                                            <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
                                        </svg>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </template>

                    <template #actions>
                        <confirms-password @confirmed="removeUser(account.id)">
                            <jet-danger-button type="button">
                                Smazat
                            </jet-danger-button>
                        </confirms-password>

                    </template>
                </jet-form-section>

                <jet-section-border/>
            </div>

            <jet-form-section :working="newAccount.processing">
                <template #title>
                    Přidání účtu
                </template>

                <template #description>
                    <p>Přidejte do své DSchránky další účet systému datových schránek.</p>

                    <p>Abychom se mohli spojit s Vaší datovou schránkou, musíte ji připojit jedním ze tří způsobů v následujícím formuláři.</p>
                </template>

                <template #form>
                    <div class="w-full col-span-6 sm:col-span-4">
                        <label class="block text-sm font-medium text-gray-700">
                            Způsob přihlášení
                            <a :href="route('faq', {id: 1}) + '#q1'" target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                                </svg>
                            </a>
                        </label>
                        <method-selector class="mt-1" v-model="newAccount.method" :disabled="newAccount.processing"/>
                    </div>

                    <ISDSAccountInputs :method="newAccount.method"
                                       :processing="newAccount.processing"
                                       v-model:username="newAccount.username"
                                       v-model:password="newAccount.password" />


                </template>

                <template #actions>
                    <jet-button @click.prevent.native="addUser" :class="newAccount.processing ? 'opacity-25' : ''" :disabled="newAccount.processing">
                        Přidat
                    </jet-button>

                </template>
            </jet-form-section>

        </div>

        <ISDSAccountAddingGuide :new-account="newAccount"
                                :mkstart="MKStart"
                                :referer="'settings.isds'"
                                @mkstarted="MKStart = false"/>

    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import DeleteUserForm from "@/Pages/Profile/DeleteUserForm";
import LogoutOtherBrowserSessionsForm from "@/Pages/Profile/LogoutOtherBrowserSessionsForm";
import JetSectionBorderAlways from '@/Jetstream/SectionBorderAlways'
import UpdatePasswordForm from "@/Pages/Profile/UpdatePasswordForm";
import TwoFactorAuthenticationForm from "@/Pages/Profile/TwoFactorAuthenticationForm";
import UpdateProfileInformationForm from "@/Pages/Profile/UpdateProfileInformationForm";

import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetDangerButton from '@/Jetstream/DangerButton'
import ConfirmsPassword from "@/Jetstream/ConfirmsPassword"
import DialogModal from "@/Jetstream/DialogModal";
import HspisPopupFirst from "../../Components/HspisPopupFirst";
import HspisPopupSecond from "../../Components/HspisPopupSecond";
import { useToast } from "vue-toastification";
import SectionBorder from "../../Jetstream/SectionBorder";
import MethodSelector from "../../Components/MethodSelector";
import ISDSAccountInputs from "../../Components/ISDSAccountInputs";
import ISDSAccountAddingGuide from "../../Components/ISDSAccountAddingGuide";
import SettingsTabsNavigation from "./SettingsTabsNavigation";
import InfoBar from "../../Components/InfoBar.vue";

export default {
    name: "SettingsISDS",
    components: {
        InfoBar,
        SettingsTabsNavigation,
        ISDSAccountAddingGuide,
        ISDSAccountInputs,
        MethodSelector,
        'jet-section-border': SectionBorder,
        HspisPopupSecond,
        HspisPopupFirst,
        ConfirmsPassword,
        UpdateProfileInformationForm,
        TwoFactorAuthenticationForm,
        JetSectionBorderAlways,
        UpdatePasswordForm, LogoutOtherBrowserSessionsForm, DeleteUserForm, AppLayout,

        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetDangerButton,
        DialogModal,
    },
    data(){
        return {
            accounts: this.$page.props.accounts,

            workingUserId: null,

            isPlannedMaintenance: this.$page.props.isPlannedMaintenance,

            showPassword: null,
            showPasswordTimeout: null,

            newAccount: {
                username: null,
                password: null,
                processing: false,
                method: 0,
                verificationStep: 0,
                sCookie: null,
                token: null,
                referer: 'settings.isds',
                working: false,
            },

            mkInterval: null,
            hspisTimeout: null,
            hspisInterval: null,
            MKStart: false,
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },
    updated(){

    },
    methods: {
        addUser(){
            if(this.newAccount.method === 4){
                if(this.newAccount.username.length !== 6)
                    return this.toast.info('Uživatelské jméno musí mít přesně 6 znaků!');
                this.newAccount.processing = true;
                this.MKStart = true;
            }
            if(this.newAccount.method === 2){
                if(this.newAccount.username.length !== 7)
                    return this.toast.info('ID Datové Schránky musí mít přesně 7 znaků!');

                this.newAccount.verificationStep = -1;
            }
            if(this.newAccount.method === 0) {
                this.$inertia.post(route('settings.progress.user.save'), this.newAccount, {
                    preserveState: false
                });
            }
            this.newAccount.processing = true;
        },

        removeUser(id){
            this.workingUserId = id;
            axios.delete(route('settings.removeUser', id))
                .then( (response) => { this.$inertia.get(route('settings.isds'), {}, {preserveState: false}) } )
                .catch( (error) => {console.log(error)} );
        },
        showPasswordOrKeyByIndex(index){
            this.workingUserId = this.accounts[index].id;
            this.hideShownPasswordOrKey();

            axios.get(route('fapi.isds.password', {id: this.accounts[index].id}), {})
                .then((response) => {
                    this.accounts[index].password = response.data.password;
                    this.showPassword = index;
                    this.workingUserId = null;
                })
                .catch((error) => {
                    this.workingUserId = null;
                    this.toast.error('Něco se pokazilo. Zkuste to později.')
                });
        },
        hideShownPasswordOrKey(){
            if(this.showPassword != null) this.accounts[this.showPassword].password = '****************';
            this.showPassword = null;
        },
        getMethodName(method){
            if(method === 0) return 'jménem a heslem';
            if(method === 4) return 'mobilním klíčem';
            if(method === 2) return 'certifikátem';
        }
    },

}
</script>

<style scoped>

</style>
